/* 浮动购物袋（全站）：购物车里没有商品时不渲染，有商品才浮现，点击直达 /cart。
   配置来自 layout/theme.liquid 里的 #ms-cart-config（后台「浮动购物车」组）。 */
(function(){
  function flag(v, fallback){
    if (v === undefined || v === null || v === '') return fallback;
    return String(v) !== 'false';
  }

  var cfg = document.getElementById('ms-cart-config');
  var enabled = cfg ? flag(cfg.dataset.enable, true) : true;
  if (!enabled) return;
  var pos = (cfg && cfg.dataset.position) || 'br';
  var hideOnCart = cfg ? flag(cfg.dataset.hideCart, true) : false;
  if (hideOnCart && /\/cart\/?$/.test(location.pathname)) return;
  if (document.querySelector('.cartb')) return;

  var link = document.createElement('a');
  link.className = 'cartb cartb--' + pos;
  link.href = window.MS_CART_URL || '/cart';
  link.setAttribute('aria-label', 'View cart');
  link.innerHTML = '<span class="cartb__ico" aria-hidden="true">'
    + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">'
    + '<path d="M5.5 8h13l-1.1 11.6a2 2 0 0 1-2 1.9H8.6a2 2 0 0 1-2-1.9L5.5 8z"/>'
    + '<path d="M9 10.5V6.8a3 3 0 0 1 6 0v3.7"/></svg></span>'
    + '<span class="cartb__count" hidden>0</span>';
  document.body.appendChild(link);
  var badge = link.querySelector('.cartb__count');

  function set(n){
    n = parseInt(n, 10) || 0;
    if (n > 0){
      badge.textContent = n > 99 ? '99+' : String(n);
      badge.hidden = false;
      link.classList.add('is-on');
      link.setAttribute('aria-label', 'View cart, ' + n + ' item' + (n > 1 ? 's' : ''));
    } else {
      badge.hidden = true;
      link.classList.remove('is-on');
    }
  }

  function refresh(){
    // 预览站没有后端：用 window.MS_CART_DEMO_COUNT 模拟件数
    if (typeof window.MS_CART_DEMO_COUNT === 'number'){ set(window.MS_CART_DEMO_COUNT); return; }
    fetch('/cart.js').then(function(r){ return r.json(); })
      .then(function(c){ set(c.item_count || 0); })
      .catch(function(){ set(0); });
  }

  window.MSCart = { refresh: refresh, set: set };
  refresh();
})();
